import { render, staticRenderFns } from "./ClientReport.vue?vue&type=template&id=57ef3232&scoped=true"
import script from "./ClientReport.vue?vue&type=script&lang=js"
export * from "./ClientReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ef3232",
  null
  
)

export default component.exports